import Button from '../../../../../components/UiElements/Button'
import DynamicForm from '../../../../../components/DynamicForm'
import React, { useRef, useEffect } from 'react'
import hatchProfileMapping from './dataMapping/hatchProfile'

import HatchProfileForm from './HatchProfileForm'
import axios from '@/services/axios'
import ButtonList from '@/components/UiElements/ListButton'
import useStateManagement from '@/hooks/stateManagement/useStateManagement'

const HatchProfile = ({ item, data, change }) => {
  //bound, close, submit,
  const myFormRef = useRef(null)

  const [contentList, setContentList] = React.useState({})

  const { runSteps: createHatchProfile, stateInProgress } = useStateManagement({
    initial: {
      main: async (state, form) => {
        return {
          method: form.formData.id ? 'PUT' : 'POST',
          update: !!form.formData.id,
          mappedData: hatchProfileMapping(form.formData),
          parentData: form?.hatch_profile_ids || [],
          contentList: form?.contentList,
          setContentList: form?.setContentList,
        }
      },
    },
    save: {
      main: async (state, form) => {
        axios('/hatchprofiles/', state?.initial?.method, state?.initial?.mappedData).then((response) => {
          let parentData = [...state?.initial?.parentData]
          if (!state?.initial?.update) {
            parentData.push(response?.id)
          }
          // Fetch the updated item from API to get properly formatted data
          axios(`/hatchprofiles/${response?.id}`, 'GET').then((updatedItem) => {
            if (state?.initial?.contentList?.selected) {
              const inlineList = state?.initial?.contentList?.list?.map((item) => {
                if (item.id === response?.id) {
                  return updatedItem
                }
                return item
              })
              state.initial.setContentList({
                list: inlineList,
                selected: response?.id,
              })
            } else {
              const inlineList = [...state?.initial?.contentList?.list, updatedItem]
              console.log('inlineList-----', inlineList)
              state.initial.setContentList({
                list: inlineList,
                selected: response?.id,
              })
            }
          })
          change(parentData, item.parent, null, null, true)
        })
      },
      startMessage: (result, state) => `${state?.initial?.update ? 'Update-' : 'SAVE-'} Hatch profile ...`,
      errorMessage: (result, state) => `${state?.initial?.update ? 'Update-' : 'SAVE-'} Hatch profile failed :(`,
      successMessage: (result, state) => `Hatch profile ${state?.initial?.update ? 'Updated' : 'Created'} :)`,
    },
  })
  const handleSaveHatchProfile = async () => {
    const formData = await myFormRef?.current?.getData()
    if (formData) {
      await createHatchProfile({
        formData: formData,
        hatch_profile_ids: data?.[item.parent] || [],
        contentList: contentList,
        setContentList: setContentList,
      })
    }
  }

  const handleFetchHatchProfile = async () => {
    axios('/hatchprofiles/', 'GET').then((response) => {
      if (response?.contents) {
        setContentList({
          list: response?.contents,
          selected: response?.contents[0]?.id,
        })

        myFormRef.current?.setData(response?.contents[0])
      }
    })
  }

  const handleAddSection = () => {
    setContentList({
      list: contentList?.list,
      selected: null,
    })
    myFormRef.current?.setData(null)
  }

  const handleSelectItem = (val) => {
    setContentList({
      list: contentList?.list,
      selected: val,
    })
    myFormRef.current?.setData(contentList?.list?.find((item) => item.id === val))
  }

  useEffect(() => {
    handleFetchHatchProfile()
  }, [])

  return (
    <div className={'flex flex-row w-[950px] '}>
      {stateInProgress && (
        <div
          className={
            'fixed top-0 left-0 w-full h-full bg-gray-600 bg-opacity-50 flex justify-center items-center z-[100]'
          }
        ></div>
      )}
      <div className={'bg-gray-100  p-xl '}>
        <div className={'w-[300px] gap-md flex-col flex'}>
          <div className={' text-title-lg text-gray-400 hidden'}>Profile List</div>
          <div className={'flex justify-center'}>
            <Button onClick={handleAddSection} className={'!rounded-full font-icon-solid w-[44px] h-[44px]'}>
              +
            </Button>
          </div>
          <div className={'flex flex-col gap-sm '}>
            {contentList ? (
              <ButtonList
                className={(selected) =>
                  `w-[100%] bg-white rounded-md border border-gray-200   p-xs hover:border-primary-500 active:shadow-focus box-border !transition-all ${
                    selected ? 'border-primary-500 border-1 shadow-select-shadow' : ''
                  }`
                }
                items={contentList?.list?.map((item, index) => ({
                  ...item,
                  value: item.id,
                  label: (
                    <div className={'flex relative flex-col text-left  gap-sm p-md'}>
                      <span className={'text-title-md capitalize'}>{item.name}</span>
                      <span className={'text-gray-400 text-sm capitalize-first'}>{item.description}</span>
                    </div>
                  ),
                  index: index,
                }))}
                //styles={sections?.list.map((i, index) => ( sectionsInnerValidation[i.sectionId]?.length > 0 ? "border-red-500 hover:border-red-500 active:border-red-500" : ""))}
                selected={contentList.selected}
                onClick={(val) => {
                  handleSelectItem(val)
                }}
              />
            ) : (
              <div>loading ..</div>
            )}
          </div>
        </div>
      </div>
      <div className={'flex flex-col pt-xl  pb-xxxl px-xxxl w[562px] box-border'}>
        <div className={' grid grid-cols-12 gap-md border-b-gray-200 border-b pb-md'}>
          <DynamicForm
            items={HatchProfileForm}
            defaultValues={{}}
            size={'md'}
            ref={myFormRef}
            onChange={(val) => {
              console.log(val, 'vali')
            }}
          />
        </div>
        <div className={'col-span-12  flex flex-col justify-end '}>
          <Button
            onClick={() => {
              handleSaveHatchProfile()
            }}
            size={'md'}
          >
            {!contentList.selected ? 'Save' : 'Update'} Hatch Profile
          </Button>
          {/*<input type={"input"} value={formData}/>*/}
        </div>
      </div>
    </div>
  )
}

const OpenHatchProfile = ({ show }) => {
  //value, onChange, data, defaultValues
  return (
    <Button
      size={'sm'}
      type={'alt'}
      className={' w-[37px] h-[37px] font-icon-solid'}
      onClick={() => {
        show()
      }}
    >
      
    </Button>
  )
}

export { HatchProfile, OpenHatchProfile }
